<template>
  <div class="section-compare">
    <div class="container">
      <div class="middle-title"><slot name="title"></slot></div>
      <!--  -->
      <div class="table-wrapper">
        <div class="table">
          <div class="legend">
            <div class="legend-options">
              <div class="only-difference">
                <input id="onlyDifference" v-model="onlyDifference" type="checkbox" />
                <label class="subtitle" for="onlyDifference">show only difference</label>
              </div>
            </div>
            <div class="params table-rows">
              <div v-for="(param, index) in params" :key="index" class="table-row">
                <div class="subtitle">{{ param.name }}</div>
              </div>
            </div>
          </div>
          <div v-for="(product, index) in products.slice(0, 3)" :key="index" class="products">
            <div class="product-info">
              <div class="picture"><img :src="product.pic" class="abs" alt="" /></div>
              <div class="product-name subtitle">{{ product.name }}</div>
              <div class="buttons">
                <div class="button"><img src="@/assets/icons/cart.svg" alt="" /></div>
                <div class="button"><img src="@/assets/icons/heart-fill.svg" alt="" /></div>
              </div>
            </div>
            <div class="params table-rows">
              <div v-for="(param, pIndex) in params" :key="pIndex" class="table-row">
                <div class="subtitle">{{ getValue(product[param.prop]) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      products: window.__compare__,
      onlyDifference: false
    }
  },

  methods: {
    getValue(value) {
      if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No'
      } else if (typeof value === 'number') {
        return value.toLocaleString()
      } else {
        return value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section-compare {
  padding-bottom: 5em;
  padding-top: 1em;
}
.table {
  display: grid;
  grid-auto-columns: minmax(15em, auto);
  grid-auto-flow: column;
  --header-height: 12em;
  // & > * {
  //   border: solid 1px;
  // }
}
.picture {
  width: 6.25em;
  height: 6.25em;
  position: relative;
  img {
    object-fit: contain;
  }
}
.product-name {
  font-weight: 600;
}
.buttons {
  display: flex;
  align-items: center;
  margin-top: 1em;
  & > * {
    opacity: 0.2;
    transition: 0.5s;
    cursor: pointer;
    &:not(:last-child) {
      margin-right: 1em;
    }
    &:hover {
      opacity: 1;
    }
  }
}
.product-info,
.legend-options {
  height: var(--header-height);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: 1em;
}
.only-difference {
  display: flex;
  align-items: center;
  input {
    margin-right: 0.5em;
  }
}
.table-row {
  height: 3.125em;
  display: flex;
  align-items: center;
  &:nth-child(2n) {
    background: #f7f8fb;
  }
}
.table-wrapper {
  position: relative;
  overflow: scroll;
}
</style>
